import { __commonJSMin as e, __toCommonJS as t } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_lodash_toarray as n } from "../../../../../lodash.toarray@4.4.0/bundled_deps/lodash.toarray/index.js";
import { require_flatten as r } from "./flatten.js";
import { require_for_each_object as i } from "./for_each_object.js";
import { require_includes as a } from "./includes.js";
import { require_map_object as o } from "./map_object.js";
import { require_filter_object as s } from "./filter_object.js";
import { require_values as c } from "./values.js";
import { require_unique as l } from "./unique.js";
import { require_is_undefined as u } from "./is_undefined.js";
import { emoji_exports as d, init_emoji as f } from "./emoji.json.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/intermoji.js
var p = /* @__PURE__ */ e(((e, p) => {
	var m = n(), h = r(), g = i(), _ = a(), v = o(), y = s(), b = c(), x = l(), S = u(), C = function(e) {
		for (var t = [], n = 0, r = e.length, i, a, o, s; n < r;) o = e.charAt(n), i = e.charCodeAt(n++), i >= 55296 && i <= 56319 && n < r ? (s = e.charAt(n), a = e.charCodeAt(n++), (a & 64512) == 56320 ? t.push([o + s, ((i & 1023) << 10) + (a & 1023) + 65536]) : (t.push([o, i]), n--)) : t.push([o, i]);
		return t;
	}, w = "__ic_", T = (f(), t(d).default), E = {};
	T.forEach(function(e, t) {
		e.forEach(function(e) {
			E[e.unicode] = {
				identifier: e.identifier,
				isEmojiBase: e.isEmojiBase,
				supportedTwemoji: e.supportedTwemoji,
				categoryIndex: t
			};
		});
	});
	var D = {
		":-)": "😀",
		":-D": "😃",
		";-)": "😉",
		"}-)": "👿",
		":-o": "😮",
		":-O": "😮",
		":-/": "😕",
		":-\\": "😕",
		"x-(": "😩",
		"X-(": "😩",
		":-(": "😞",
		"B-)": "😎",
		":-p": "😛",
		":-P": "😛",
		":-@": "😠",
		":-|": "😐",
		":-$": "😳"
	};
	g(D, function(e, t) {
		E[e][w + "ascii"] = t;
	});
	var O = /* @__PURE__ */ "⁉.⁉️.‼️.✂.✈.✉.❤.✌.✏.⚠.🈷.🈂.Ⓜ.Ⓜ️.✒.✔.✖.◼.◻.™.☀.☁.♠.♠️.♣.♣️.♥.♥️.♦.♦️.♨.▪.▫.ℹ.↔.↔️.↕.↖.↖️.↗.↗️.↘.↘️.↙.↙️.☑.〰.♻.〽.▶.▶️.☝.✳.✴.❄.❇.⬆.⬇.⬅.➡.◀.◀️.↩.↪.⤴.⤴️.⤵.⤵️.㊗.㊙.☺.☺️.☹️.☹.‼.🅰.🅰️.🅱.🅱️.🅿.🅿️.🅾.🅾️.🇯.🇰.🇩.🇨.🇺.🇫.🇪.🇮.🇷.🇬.☔.⭐.⚡.☕.☎.⚓.♈.♉.♐.♑.♒.♓.♿.♊.♋.♌.♍.♎.♏.◾.◽.⚫.⚪".split("."), k = {};
	g(E, function(e, t) {
		k[w + e.identifier] = t;
	});
	var A = 10, j = T.map(function(e) {
		return e.map(function(e) {
			return e.unicode;
		});
	}), M = function(e, t, n) {
		for (var r = [], i = 0, a = 0; i + n <= t.length;) {
			var o = t.slice(i, i + n);
			e.isSupportedAscii(o) && N(t, i - 1, i + n) ? (a < i && r.push(t.slice(a, i)), r.push(o), i += n, a = i) : ++i;
		}
		return a < t.length && r.push(t.slice(a, t.length)), r;
	}, N = function(e, t, n) {
		var r = !1, i = !1;
		return (t < 0 || /\s/.test(e.charAt(t))) && (r = !0), (n >= e.length || /\s/.test(e.charAt(n))) && (i = !0), r && i;
	};
	p.exports = {
		getGroupRepresentatives: function() {
			return [
				["😄", "Smileys & Emotion"],
				["👋", "People & Body"],
				["🏻", "Component"],
				["🌸", "Animals & Nature"],
				["🍇", "Food & Drink"],
				["🌍", "Travel & Places"],
				["🎈", "Activities"],
				["🔔", "Objects"],
				["🔠", "Symbols"],
				["🇮🇪", "Flags"]
			];
		},
		getUglyNativeEmoji: function() {
			return O.slice();
		},
		isUglyNativeEmoji: function(e) {
			return _(O, e);
		},
		hasNativeSupport: function(e) {
			var t, n = "😀";
			if (!e.createElement("canvas").getContext || (t = e.createElement("canvas").getContext("2d"), typeof t.fillText != "function")) return !1;
			t.textBaseline = "top", t.font = "32px Arial", t.fillText(n, 0, 0);
			var r = t.getImageData(16, 16, 1, 1);
			return r ? r.data[0] !== 0 : !1;
		},
		isSupportedUnicode: function(e) {
			return E.hasOwnProperty(e);
		},
		isEmojiBaseUnicode: function(e) {
			return E[e].isEmojiBase;
		},
		identifierFromUnicode: function(e) {
			return E[e].identifier;
		},
		asciiFromUnicode: function(e) {
			return E[e][w + "ascii"];
		},
		groupFromUnicode: function(e) {
			return E[e].categoryIndex;
		},
		isSupportedAscii: function(e) {
			return D.hasOwnProperty(e);
		},
		unicodeFromAscii: function(e) {
			return D[e];
		},
		isSupportedIdentifier: function(e) {
			return k.hasOwnProperty(w + e);
		},
		unicodeFromIdentifier: function(e) {
			return k[w + e];
		},
		N_GROUPS: A,
		prettyEmoticonsUnicodeGroups: function() {
			return j.map(function(e) {
				return e.filter(function(e) {
					if (!_(O, e)) return e;
				});
			});
		},
		allEmoticonsUnicodeGroups: j,
		allEmoticonsUnicodeList: Object.keys(E),
		allEmoticonsIdentifierList: v(E, function(e, t) {
			return e.identifier;
		}),
		prettyEmoticonsIdentifierList: function() {
			return v(y(E, function(e, t) {
				return !_(O, t) && e.isEmojiBase;
			}), function(e, t) {
				return e.identifier;
			});
		},
		asciiEmoticonsUnicodeList: x(b(D)),
		asciiEmoticonsIdentifierList: x(b(D)).map(function(e) {
			return E[e].identifier;
		}),
		MIN_ASCII_LENGTH: 3,
		MAX_ASCII_LENGTH: 3,
		asciiEmoticonsAsciiList: Object.keys(D),
		splitOnUnicodeEmojis: function(e) {
			if (S(e)) return [];
			var t = m(e), n = [], r = !0;
			return t.forEach(function(e) {
				if (this.isSupportedUnicode(e)) n.push(e), r = !0;
				else {
					if (r) n.push(e);
					else {
						var t = n.pop();
						n.push(t + e);
					}
					r = !1;
				}
			}.bind(this)), n;
		},
		splitOnAsciiEmojis: function(e) {
			if (S(e)) return [];
			for (var t = [e], n = this.MAX_ASCII_LENGTH; n >= this.MIN_ASCII_LENGTH; --n) {
				for (var r = [], i = 0; i < t.length; ++i) r = r.concat(M(this, t[i], n));
				t = r;
			}
			return t;
		},
		getAllModifiedForBaseEmoji: function(e) {
			var t = [];
			if (e === "") return t;
			for (var n in E) n.indexOf(e) > -1 && t.push(n);
			return t;
		},
		splitOnUnicodeAndAsciiEmojis: function(e) {
			return S(e) ? [] : h(this.splitOnUnicodeEmojis(e).map(function(e) {
				return this.splitOnAsciiEmojis(e);
			}.bind(this)));
		},
		substituteUnicodeForAsciiEmojis: function(e) {
			return S(e) || e === null ? "" : this.splitOnAsciiEmojis(e).map(function(e) {
				return this.isSupportedAscii(e) ? this.unicodeFromAscii(e) : e;
			}.bind(this)).reduce(function(e, t) {
				return e + t;
			}, "");
		},
		wrapUnicodeEmojiInTitledSpans: function(e, t, n, r) {
			return S(t) ? "" : this.splitOnUnicodeEmojis(t).map(function(t) {
				if (this.isSupportedUnicode(t)) {
					if (this.isUglyNativeEmoji(t)) return this.fallbackImage(e, t, n);
					var i = "";
					return r && (i = " role=\"img\" aria-label=\"" + this.identifierFromUnicode(t) + "\""), "<span title=\"" + this.identifierFromUnicode(t) + "\"" + i + ">" + t + "</span>";
				} else return t;
			}.bind(this)).reduce(function(e, t) {
				return e + t;
			}, "");
		},
		substituteUnicodeForColonified: function(e) {
			for (var t = function(e) {
				return ":" + e + ":";
			}, n = !0, r = "", i = "", a = 0; a < e.length; a++) e[a] === ":" ? (n ? (n = !1, i += r) : (n = !0, i += this.isSupportedIdentifier(r) ? this.unicodeFromIdentifier(r) : t(r)), r = "") : r += e[a];
			return n || (i += ":"), i += r;
		},
		codepointIndexFromUnicode: function(e) {
			return C(e).map(function(e) {
				return e[1];
			});
		},
		fallbackImage: function(e, t, n) {
			return S(t) ? "" : this.splitOnUnicodeAndAsciiEmojis(t).map(function(t) {
				return this.isSupportedAscii(t) ? this.twemojiSpanTag(e, this.unicodeFromAscii(t), n) : this.isSupportedUnicode(t) ? this.twemojiSpanTag(e, t, n) : t;
			}.bind(this)).join("");
		},
		twemojiStyleString: function(e, t) {
			return "display:inline-block;height:" + e + "px;width:" + e + "px;background-image:url(" + this.twemojiSVGUri(t) + ");background-size:contain;";
		},
		twemojiSpanTag: function(e, t, n) {
			return S(n) && (n = "intermoji-default-class"), "<span style=\"" + this.twemojiStyleString(e, t) + "\" title=\"" + this.identifierFromUnicode(t) + "\" class=\"" + n + "\" role=\"img\" aria-label=\"" + this.identifierFromUnicode(t) + "\"></span>";
		},
		twemojiSVGUri: function(e) {
			var t = this.getSupportedTwemoji(e);
			return "https://js.intercomcdn.com/images/stickers/v2/svg/" + (this.codepointIndexFromUnicode(t).map(function(e) {
				return e.toString(16);
			}).join("-").toLowerCase() + ".svg");
		},
		getSupportedTwemoji: function(e) {
			return e in E && E[e].supportedTwemoji || e;
		},
		getEmojiFromSupportedTwemoji: function(e) {
			return Object.keys(E).find(function(t) {
				return E[t].supportedTwemoji === e;
			}) || e;
		}
	};
}));
//#endregion
export default p();
export { p as require_intermoji };
